var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.091 12.617"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "twitter",
    d: "M14.591.558a6.981 6.981 0 0 1-2.011.98 2.869 2.869 0 0 0-5.035 1.92v.641a6.828 6.828 0 0 1-5.764-2.9S-.781 6.958 4.983 9.521A7.455 7.455 0 0 1 .5 10.802c5.764 3.2 12.81 0 12.81-7.366a2.882 2.882 0 0 0-.051-.532A4.945 4.945 0 0 0 14.591.558Z",
    fill: "none",
    stroke: "#8D92A8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTwitter;